/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

// Bulma Framework global scss
import "./src/styles/mystyles.scss"

// Google Analytics 4: enviar page_view en la carga inicial y en cada
// navegación interna (Gatsby es SPA, no recarga la página entre rutas)
export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search + location.hash,
    })
  }
}

// Service worker (gatsby-plugin-offline): cuando hay contenido nuevo, el SW viejo
// sigue sirviendo la versión cacheada hasta que se cierran todas las pestañas.
// Mostramos un aviso no intrusivo para que el usuario recargue cuando quiera —
// sin esto, la "carta do dia" o cambios del sitio pueden verse desactualizados.
export const onServiceWorkerUpdateReady = () => {
  if (typeof document === "undefined" || document.getElementById("eg-sw-update")) return
  const bar = document.createElement("div")
  bar.id = "eg-sw-update"
  bar.setAttribute("role", "status")
  const span = document.createElement("span")
  span.textContent = "🌙 Nova versão disponível"
  const btn = document.createElement("button")
  btn.type = "button"
  btn.textContent = "Atualizar"
  btn.addEventListener("click", () => window.location.reload(true))
  const close = document.createElement("button")
  close.type = "button"
  close.className = "eg-sw-close"
  close.setAttribute("aria-label", "Fechar")
  close.textContent = "✕"
  close.addEventListener("click", () => bar.remove())
  bar.appendChild(span)
  bar.appendChild(btn)
  bar.appendChild(close)
  document.body.appendChild(bar)
}

// Canonical self-ref en todas las páginas (ver src/components/canonical-fallback.js)
export { wrapPageElement } from "./src/components/canonical-fallback"
